<template>
  <div class="guest-item">
    <div class="guest-img-wrapper">
      <img
        v-for="(item, index) in guestInfo.pcInfo"
        :key="index"
        class="guest-img"
        :src="item"
      />
      <div class="paly-btn-wrapper">
        <div v-if="guestInfo.repalySrc" class="play-btn">
          <img
            @click="playCurVideo(guestInfo.repalySrc)"
            alt="播放视频"
            :src="
              guestInfo.repalySrc2
                ? 'https://summit-img.geekpark.net/if2021/视频一.svg'
                : 'https://summit-img.geekpark.net/if2021/视频.svg'
            "
          />
        </div>
        <div v-if="guestInfo.repalySrc2" class="play-btn play-btn-2">
          <img
            @click="playCurVideo(guestInfo.repalySrc2)"
            alt="播放视频"
            src="https://summit-img.geekpark.net/if2021/视频二.svg"
          />
        </div>
        <div v-if="guestInfo.repalySrc3" class="play-btn play-btn-3">
          <img
            @click="playCurVideo(guestInfo.repalySrc3)"
            alt="播放视频"
            src="https://summit-img.geekpark.net/if2021/视频三.svg"
          />
        </div>
      </div>
    </div>
    <div
      class="subject-title"
      :class="{
        'single-person': guestInfo.pcInfo.length == 1,
        'little-size':
          guestInfo.subjectTitle.length >= 26 && guestInfo.pcInfo.length == 1,
      }"
    >
      {{ guestInfo.subjectTitle }}
    </div>
  </div>
</template>

<script>
export default {
  naem: "GuestItem",
  props: {
    guestInfo: Object,
  },
  computed: {
    curVideoSrc() {
      return this.$store.state.curVideoSrc;
    },
  },
  methods: {
    playCurVideo(vSrc) {
      if (!vSrc) return;
      const vIframeWrapper = document.getElementById(
        "geekpark_video_iframe_wrapper"
      );
      const vIframe = document.getElementById("geekpark_video_iframe");
      if (vIframeWrapper.style.display === "none") {
        vIframeWrapper.style.display = "block";
        vIframe.src = vSrc;
        this.$store.commit("handleVSrcToggle", vSrc);
      } else {
        if (vSrc === this.curVideoSrc) return;
        vIframe.src = vSrc;
        this.$store.commit("handleVSrcToggle", vSrc);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.guest-item {
  padding: 2vh 2vh 1vh 2vh;
  background: #fff;
  margin-right: 2vh;
  .guest-img-wrapper {
    display: flex;
    align-content: center;
    justify-content: center;
    position: relative;
    .guest-img {
      height: 67vh;
      width: auto;
      &:not(:last-child) {
        margin-right: 1vh;
      }
    }
    .paly-btn-wrapper {
      position: absolute;
      bottom: 3.4vh;
      left: 2.2vh;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: flex-start;
      .play-btn {
        img {
          height: 3vh;
          width: auto;
          margin-right: 4px;
          &:hover {
            cursor: pointer;
            transform: scale(1.1);
          }
        }
      }
    }
  }
  .subject-title {
    height: 10vh;
    font-size: 3vh;
    font-weight: bold;
    padding-top: 2vh;
    &.single-person {
      width: 36vh;
    }
    &.little-size {
      font-size: 2.4vh;
    }
  }
}
</style>